import { Order as OrderModel } from 'domains/profile';
import { CurrencySymbol } from 'models';
import { Content } from './components';

const OrderDetails = ({
  order,
  onRepeatOrder,
  onRetryPayment,
  currency,
  onClose,
}: {
  order: OrderModel;
  onRepeatOrder: ({ order }: { order: OrderModel }) => void;
  onRetryPayment: ({ order }: { order: OrderModel }) => void;
  currency: CurrencySymbol;
  onClose: () => void;
}) => {
  return (
    <Content
      currency={currency}
      onClose={onClose}
      order={order}
      onRepeatOrder={onRepeatOrder}
      onRetryPayment={onRetryPayment}
    />
  );
};

export default OrderDetails;